import { Alert, Box, useMediaQuery } from '@mui/material'
import React from 'react'
import { useTranslations } from 'use-intl'
import ForgotPasswordForm from './ForgotPasswordForm'
import SignInForm from './SignInForm'
import SignUpForm from './SignUpForm'

interface GoogleUserData {
    email: string
    firstName: string
    lastName: string
    fullName: string
    googleId: string
    picture?: string
    userId?: string | number
}

export interface SignInModalProps {
    open: boolean
    onClose: () => void
    form: any
    status: any
    handlers: any
    benefits: { text: string; icon: React.ReactNode }[]
    t: (key: string) => string
    registerWithLabel: string
    showGoogleSignIn: boolean
    onGoogleSignIn?: (userData: GoogleUserData) => void
    setActiveTab: (num: number) => void
    showCTLoginFlowFormFlyin: boolean
    onCTLoginFlowBackClick: () => void
}

export const SignInModal: React.FC<SignInModalProps> = ({
    form,
    status,
    handlers,
    showGoogleSignIn,
    onGoogleSignIn,
    t,
    setActiveTab,
    showCTLoginFlowFormFlyin,
    onCTLoginFlowBackClick
}) => {
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'))

    return (


        <Box
            sx={{
                flex: 1.2,
                pt: isMobile ? 2 : 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                minWidth: 300
            }}
        >


            {!status.forgot ? (
                <>
                    {status.error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {status.error}
                        </Alert>
                    )}
                    {status.success && (
                        <Alert severity="success" sx={{ mb: 2 }}>
                            {status.success}
                        </Alert>
                    )}
                    {status.tab === 0 ? (
                        <SignInForm
                            isMobile
                            form={form}
                            status={status}
                            handlers={handlers}
                            t={t}
                            showGoogleSignIn={showGoogleSignIn}
                            onGoogleSignIn={onGoogleSignIn || (() => { })}
                            setActiveTab={setActiveTab}
                            showCTLoginFlowFormFlyin={showCTLoginFlowFormFlyin}
                            onCTLoginFlowBackClick={onCTLoginFlowBackClick}
                        />
                    ) : (
                        <SignUpForm
                            form={form}
                            status={status}
                            handlers={handlers}
                            t={t}
                            showGoogleSignIn={showGoogleSignIn}
                            onGoogleSignIn={onGoogleSignIn || (() => { })}
                            setActiveTab={setActiveTab}

                        />
                    )}
                </>
            ) : (
                <ForgotPasswordForm form={form} status={status} handlers={handlers} t={t} />
            )}
        </Box>

    )
}
